import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import { inject, observer } from 'mobx-react';
import c from 'classnames';
import { RoomStatus, membersDrawerWidth } from 'components/LiveClass/utils/consts';
import getRightSeparation from 'components/LiveClass/utils/getRightSeparation';
import createRootElement from 'components/LiveClass/utils/createRootElement';
import LiveClassMembersButton from 'components/LiveClass/model-views/LiveClassMembersButton';
import CircleIconButton from '../../components/CircleIconButton';
import UserMedia from '../../components/UserMedia';
import { hideLiveClassActionBtns, showBringActionsBack } from './hideLiveClassActionBtns';
import * as s from './styles';

@inject(stores => ({ model: stores.liveClassModel }))
@observer
class LocalUserMedia extends Component {
  constructor(props) {
    super(props);

    this.rootNode = createRootElement('local-user-media', '');
  }

  componentWillUnmount() {
    this.rootNode.remove();
  }

  hideActionBtns = () => {
    hideLiveClassActionBtns(true);
    showBringActionsBack(true);
  };

  showActionBtn = () => {
    hideLiveClassActionBtns(false);
    showBringActionsBack(false);
  };

  renderLiveClassMembersButton() {
    const { model } = this.props;
    const { isMobile } = model.store;
    if (isMobile) {
      return <LiveClassMembersButton className="liveClassMembersButton" />;
    }
    return null;
  }

  renderUserMedia() {
    const { model } = this.props;
    const { roomStatus } = model.store.room;

    if (roomStatus !== RoomStatus.Connected) {
      return null;
    }

    const { localUserMedia, membersDrawer, isMobile } = model.store;
    const {
      isVideoEnabled,
      isAudioEnabled,
      isScreenShareEnabled,
      toggleVideo,
      toggleAudio,
      toggleScreenShare
    } = localUserMedia;

    const videoButtonIcon = isVideoEnabled ? 'video' : 'muteVideo';
    const audioButtonIcon = isAudioEnabled ? 'record' : 'disabledRecord';
    const screenShareButtonIcon = isScreenShareEnabled ? 'desktop' : 'desktopDisabled';

    const isDrawerVisible = membersDrawer.isDrawerVisible;
    const right = isMobile ? 0 : isDrawerVisible ? membersDrawerWidth + 20 : getRightSeparation();
    let userVideoRight = 20;
    if (document.getElementsByClassName('stickyNarratButton').length) {
      userVideoRight = 94;
    }

    return (
      <React.Fragment>
        <div className={c(s.root(isMobile), s.commonMediaClass(right))} id="live-class-action-btns">
          {isMobile ? (
            <CircleIconButton
              active={false}
              className={s.button}
              icon={{ type: 'arrow-down' }}
              onClick={this.hideActionBtns}
              isMobile={isMobile}
            />
          ) : (
            <CircleIconButton
              active={isScreenShareEnabled}
              className={s.button}
              icon={{ type: screenShareButtonIcon }}
              onClick={toggleScreenShare}
              isMobile={isMobile}
            />
          )}
          <CircleIconButton
            active={isVideoEnabled}
            className={s.button}
            icon={{ type: videoButtonIcon }}
            onClick={toggleVideo}
            isMobile={isMobile}
          />
          <CircleIconButton
            active={isAudioEnabled}
            className={s.button}
            icon={{ type: audioButtonIcon }}
            onClick={toggleAudio}
            isMobile={isMobile}
          />
          {this.renderLiveClassMembersButton()}
          <UserMedia
            mediaStore={localUserMedia}
            showAudio={false}
            showScreenShare={false}
            showName={false}
            showFullScreen={false}
            isMobile={isMobile}
            className={s.localUserVideo(isMobile, userVideoRight)}
          />
        </div>
        {isMobile ? (
          <div className={s.showActionBtn} id="live-class-action-btns-arrow-up">
            <CircleIconButton
              active={false}
              className={s.button}
              icon={{ type: 'arrow-up' }}
              onClick={this.showActionBtn}
              isMobile={isMobile}
            />
          </div>
        ) : null}
      </React.Fragment>
    );
  }

  render() {
    return createPortal(this.renderUserMedia(), this.rootNode);
  }
}

export default LocalUserMedia;
